export default "__VITE_ASSET__fe4da998__"